module.exports = __webpack_public_path__ + "img/85.2.TN.b1c3c0ec.png";